export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12408.1add09a8.jpg";